import { creategetRequest, createDeleteRequest } from './request';
import { getCompId, createHeaders } from '../more/utils';
import {
  URL_LINKS_GET_SETTINGS,
  URL_LINKS_GET_COUNT,
  URL_LINKS_GET_MEDIA_LINKS,
} from '../../constants';

const linksUrl = '/links-api/';
const componentUrl = 'components';
const compId = getCompId();

export const getInstagramMediasSettings = (accountType) => {
  return creategetRequest(linksUrl + URL_LINKS_GET_SETTINGS, { accountType })
    .then((res) => res.data.payload)
    .catch((err) => err);
};

export const getInstagramMediasLinksCount = (
  mediasIds,
  mediaLinks,
  isTemplate,
) => {
  return creategetRequest(linksUrl + URL_LINKS_GET_COUNT, {
    ids: mediasIds,
    links: mediaLinks,
    compId,
    isTemplate,
  });
};

export const deleteComponentData = () => {
  return createDeleteRequest(`${linksUrl}${componentUrl}/${compId}`);
};

/**
 * Get instagram data specific media id.
 */
export const getInstagramMediaLinks = (
  mediaId,
  mediaLink,
  accessToken,
  userId,
  isBusinessApp,
  isConnected,
) => {
  if (isConnected && accessToken && userId) {
    return creategetRequest(
      linksUrl + URL_LINKS_GET_MEDIA_LINKS + mediaId,
      {
        media_link: mediaLink,
        compId: compId,
        isTemplate: !isConnected,
      },
      createHeaders(accessToken, userId, isBusinessApp),
    )
      .then((res) => {
        if (res.data.product_links.length > 0) {
          res.data.product_links = res.data.product_links.filter(
            (product) => product.active,
          );
        }
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  } else {
    return new Promise((resolve) => {
      resolve({ product_links: [] });
    });
  }
};
